import { computed } from 'vue';
import getDashedTitle from '@/utilities/getDashedTitle';
import { ResourceType } from '@/types/resources';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import constants from '@/utilities/constants';

export default function useOpenCard() {
  const store = useStore();
  const router = useRouter();
  const route = useRoute();
  const teamSlug = computed((): string => {
    return store.getters.getTeamSlug;
  });

  const setCurrentCard = (cardId: string, displayedCardParams: any = {}) => {
    store.dispatch('setDisplayedCards', [{ id: cardId, ...displayedCardParams }]);
  };

  const getPathName = (cardType: string | undefined) => {
    return cardType === ResourceType.Epic ? constants.epicRoute.path : 'card';
  };

  const openCard = (card: any, displayedCardParams: any = {}) => {
    const pathName = getPathName(card.type);
    const baseRoute = `/${teamSlug.value}/${pathName}-${card.id}`;
    let calculatedRoute = baseRoute;
    if (card.title) {
      const dashedTitle = getDashedTitle(card.title);
      calculatedRoute = `${baseRoute}-${dashedTitle}`;
    }

    if (route.path === calculatedRoute) return;

    setCurrentCard(card.id, displayedCardParams);
    router.push({
      path: calculatedRoute,
      query: {
        userNavigated: 'true',
      },
    });
  };

  return {
    openCard,
  };
}
